export const FETCH_CORE_ASSORTMENT_COUNT = 'FETCH_CORE_ASSORTMENT_COUNT';
export const FETCH_CORE_ASSORTMENT_COUNT_FULFILLED = 'FETCH_CORE_ASSORTMENT_COUNT_FULFILLED';
export const FETCH_CORE_ASSORTMENT_COUNT_REJECTED = 'FETCH_CORE_ASSORTMENT_COUNT_REJECTED';
